import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs/internal/Observable';
import { CrudDataService } from '../../shared/services/crud-data.service';
import { SecurityService } from '../../shared/services/security.service';
import { Configuration } from '../../app.configuration.service';
import { Contrato } from 'src/app/model/contrato/contrato';
import { ContratoAnexo } from 'src/app/model/contrato/contratoAnexo';
import { SearchFilterBase } from 'src/app/shared/model/search/searchFilterBase';
import { FileInfo } from 'src/app/shared/model/generic/fileInfo';

@Injectable()
export class ContratoDataService extends CrudDataService<Contrato> {

  constructor(protected http: HttpClient, protected configuration: Configuration, protected securityService: SecurityService) {
    super(http, configuration, securityService);
    this.controllerName = 'v1/Contrato';
  }

  public getAnexos = (contratoId: number): Observable<ContratoAnexo> => {
    return this.httpGet('GetAnexos/' + contratoId);
  }

  public uploadAnexo = (anexo: ContratoAnexo): Observable<boolean> => {
    const toPost = JSON.stringify(anexo);
    return this.httpPost('SubmeterAnexo', toPost);
  }

  public registoKms = (contratoId: number, kms: number): Observable<any> => {
    const toPost = JSON.stringify({ contratoId: contratoId, kms: kms});
    return this.httpPost('RegistoKms', toPost);
  }

  public SearchAnalise = (filter: SearchFilterBase): Observable<FileInfo> => {
    const toSend =JSON.stringify(filter);
    return this.httpPostGetFile('SearchAnalise', toSend);
  }

}
